import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_user_details',
};

export const getUserDetails = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
